<content-viewer 
  *ngIf="body" 
  [content]="body" 
  (docRendered)="handleDocRendered($event)">
</content-viewer>